module.exports = __webpack_public_path__ + "static/img/David-Fifita.95d065a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Fifita.jpg
// module id = x2MC
// module chunks = 0